var map = {
	"./account-number.svg": 1236,
	"./account-star.svg": 1237,
	"./account.svg": 1238,
	"./angle_down.svg": 1239,
	"./angle_right_circle.svg": 1240,
	"./angle_up.svg": 1241,
	"./arrow_down.svg": 1242,
	"./arrow_left.svg": 1243,
	"./arrow_right.svg": 1244,
	"./arrow_up.svg": 1245,
	"./arrowdown2.svg": 1246,
	"./arrowup2.svg": 1247,
	"./back.svg": 1248,
	"./check-circle-fill.svg": 1249,
	"./check-circle.svg": 1250,
	"./check.svg": 1251,
	"./circle-line.svg": 1252,
	"./close-x.svg": 1253,
	"./close.svg": 1254,
	"./close_fill.svg": 1255,
	"./close_line.svg": 1256,
	"./contact.svg": 1257,
	"./current.svg": 1258,
	"./date.svg": 1259,
	"./defaultIcon.svg": 1260,
	"./default_image.svg": 1261,
	"./delete.svg": 1262,
	"./device.svg": 1263,
	"./disable.svg": 1264,
	"./dropdown.svg": 1265,
	"./edit.svg": 1266,
	"./file-ppt-fill.svg": 1267,
	"./file-unknown-fill.svg": 1268,
	"./file-video-fill.svg": 1269,
	"./file-word-fill.svg": 1270,
	"./lookup.svg": 1271,
	"./message-error.svg": 1272,
	"./message-success.svg": 1273,
	"./minus.svg": 1274,
	"./more.svg": 1275,
	"./notification.svg": 1276,
	"./orders_fill.svg": 1277,
	"./plus.svg": 1278,
	"./plus_bold.svg": 1279,
	"./save.svg": 1280,
	"./upload.svg": 1281,
	"./wrong-circle.svg": 1282
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1557;


//////////////////
// WEBPACK FOOTER
// ./~/vue-xpc/src/assets/icons/svgs nonrecursive ./~/rt-svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}! .svg$
// module id = 1557
// module chunks = 72